"use client";

import styles from "./titleWithDescriptionV2.module.scss";
import { useEffect, useRef } from "react";
import SplitType from "split-type";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useRouter } from "next/router";

function TitleWithDescriptionV2({
  title,
  description,
  light = false,
  refreshTrigger,
}: {
  title: string;
  description: string;
  light?: boolean;
  refreshTrigger?: string;
}) {
  const router = useRouter();
  const containerRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const descriptionRef = useRef<HTMLParagraphElement>(null);

  // useEffect(() => {
  //   gsap.registerPlugin(ScrollTrigger);
  //   const splitTitle = new SplitType(titleRef.current, {
  //     types: "lines,chars,words",
  //     tagName: "span",
  //   });

  //   const mainTl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: containerRef.current,
  //       start: "top 80%",
  //       toggleActions: "play none none reverse",
  //     },
  //     defaults: {
  //       ease: "power2.out",
  //       duration: 1.2,
  //     },
  //   });

  //   mainTl.from(splitTitle.words, {
  //     opacity: 0.3,
  //     duration: 1.2,
  //     stagger: 0.3,
  //     ease: "power1.out",
  //   });

  //   gsap.from(descriptionRef.current, {
  //     scrollTrigger: {
  //       trigger: descriptionRef.current,
  //       start: "top 80%",
  //       toggleActions: "play none none reverse",
  //     },
  //     opacity: 0,
  //     y: 20,
  //     delay: 0.2,
  //     duration: 0.5,
  //     ease: "power1.out",
  //   });

  //   return () => {
  //     ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  //     splitTitle.revert();
  //     mainTl.kill();
  //   };
  // }, [refreshTrigger, router.asPath]);

  return (
    <div
      ref={containerRef}
      className={`${styles["titleWithDescriptionV2"]} ${
        light ? styles["light"] : ""
      }`}
    >
      <h2
        ref={titleRef}
        dangerouslySetInnerHTML={{ __html: title }}
        className={`${styles["titleWithDescriptionV2Title"]} font-size-64 line-height-title`}
      ></h2>
      <p
        ref={descriptionRef}
        dangerouslySetInnerHTML={{ __html: description }}
        className={`${styles["titleWithDescriptionV2Description"]} font-size-24 line-height-content`}
      ></p>
    </div>
  );
}

export default TitleWithDescriptionV2;
